/**
 * PARCELAMENTO — Atualização dinâmica por variante
 * -----------------------------------------------------------------------
 * Escuta o evento "variant:change" despachado pelo tema Impact quando o
 * cliente seleciona uma variante diferente. Recalcula o valor da parcela
 * e atualiza o DOM do parcelamento sem reload de página.
 *
 * Compatível com Shopify Online Store 2.0 / Impact theme.js.
 * Não usa jQuery nem modifica nenhuma outra funcionalidade do tema.
 * -----------------------------------------------------------------------
 */
(function () {
  'use strict';

  /**
   * Formata um valor em centavos para moeda brasileira.
   * Segue o mesmo formato que o Liquid |money usa com a config da loja.
   * Ex: 5996 → "R$ 59,96"
   */
  function formatMoney(cents) {
    var format =
      (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) ||
      (window.theme && window.theme.moneyFormat) ||
      'R$ {{amount_with_comma_separator}}';

    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }

    var value = cents / 100;

    function withSeparators(num, decimals, thousands, decimalSep) {
      var fixed = num.toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? parts[0] + decimalSep + parts[1] : parts[0];
    }

    var formatted;
    if (format.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
      formatted = withSeparators(value, 0, '.', ',');
    } else if (format.indexOf('amount_with_comma_separator') !== -1) {
      formatted = withSeparators(value, 2, '.', ',');
    } else if (format.indexOf('amount_no_decimals') !== -1) {
      formatted = withSeparators(value, 0, ',', '.');
    } else {
      formatted = withSeparators(value, 2, ',', '.');
    }

    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, formatted);
  }

  /**
   * Atualiza o badge de parcelamento na página do produto.
   * @param {number} price  preço em centavos
   * @param {HTMLElement} wrapper  o elemento [data-parcelamento-wrapper]
   */
  function updateParcelamento(price, wrapper) {
    if (!wrapper || !price || price <= 0) return;

    var maxParcelas = parseInt(wrapper.dataset.parcelas, 10) || 3;
    var texto      = wrapper.dataset.texto  || 'em até';
    var sufixo     = wrapper.dataset.sufixo || 'sem juros';
    var badge      = wrapper.querySelector('.parcelamento-badge');

    if (!badge) return;

    badge.setAttribute('data-updating', '');

    var valorParcela = Math.floor(price / maxParcelas);
    var valorFormatado = formatMoney(valorParcela);

    var textEl = badge.querySelector('.parcelamento-badge__text');
    if (textEl) {
      textEl.innerHTML =
        texto + ' ' + maxParcelas + 'x de ' +
        '<strong>' + valorFormatado + '</strong>' +
        ' ' + sufixo;
    }

    requestAnimationFrame(function () {
      badge.removeAttribute('data-updating');
    });
  }

  /**
   * Registra listener no formulário de produto para "variant:change".
   * Usa delegação de evento no document para funcionar mesmo com
   * seções renderizadas por AJAX (quick buy, featured product, etc.).
   */
  document.addEventListener('variant:change', function (event) {
    if (!event.detail || !event.detail.variant) return;

    var variant = event.detail.variant;
    var price = variant.price;

    // Encontra o wrapper de parcelamento na página do produto.
    // Pode haver mais de um em casos de featured product + main product.
    var wrappers = document.querySelectorAll('[data-parcelamento-wrapper]');
    wrappers.forEach(function (wrapper) {
      updateParcelamento(price, wrapper);
    });
  }, true /* captura — garante que roda antes de outros listeners */);

})();
